import capitalize from 'lodash/capitalize'

function fieldTransformations(field, value) {
    if (!field || !value) {
        return value
    }

    let newValue = value
    if (field?.capitalize) {
        newValue = capitalize(newValue)
    } else if (field?.upperCase) {
        newValue = newValue.toUpperCase(newValue)
    }

    return newValue
}

export { fieldTransformations }
